import React, { useEffect } from "react";
import {
  NewSingleFormComponent,
  NewSingleFormComponentProps,
} from "./NewSingleFormComponent";
import { Form } from "semantic-ui-react";
import {
  NewMultipleFormComponent,
  NewMultipleFormComponentProps,
} from "./NewMultipleFormComponentProps";

export const NewNewFormComponent = (props: {
  props: NewNewFormComponentProps;
  data: any;
  setData: any;
}) => {
  const [errorMessage, setErrorMessage] = React.useState<string>("");

  useEffect(() => {
    props.setData(props.props.startingData);
  }, [props.props.resetFormCounter]);

  return (
    <Form>
      {errorMessage !== "" && (
        <div style={{ color: "red" }} id="error-message">
          {errorMessage}
        </div>
      )}
      {props.props.form.type === "single_form" && (
        <NewSingleFormComponent
          props={props.props.form}
          data={props.data}
          setData={props.setData}
        />
      )}
      {props.props.form.type === "multiple_form" && (
        <NewMultipleFormComponent
          props={props.props.form}
          data={props.data}
          setData={props.setData}
        />
      )}
    </Form>
  );
};

export function isFormCompleted(
  form: NewSingleFormComponentProps,
  data: any,
): boolean {
  for (const field of form.formFields) {
    if (
      (field.type === "password" || field.type === "text") &&
      field.required
    ) {
      if (data[field.key] === undefined || data[field.key] === "") {
        return false;
      }
    }
  }
  return true;
}

export class NewNewFormComponentProps {
  form: NewSingleFormComponentProps | NewMultipleFormComponentProps;
  startingData: any;
  resetFormCounter = 0;

  constructor(input: {
    form: NewSingleFormComponentProps | NewMultipleFormComponentProps;
    startingData: any;
  }) {
    this.form = input.form;
    this.startingData = input.startingData;
  }

  public resetForm() {
    this.resetFormCounter += 1;
  }

  public getData(data: any): any {
    if (this.form.type === "single_form") {
      const returnData: any = data;
      for (const formField of this.form.formFields) {
        if (
          formField.type === "query_dropdown" &&
          returnData[formField.key] === 0
        ) {
          returnData[formField.key] = undefined;
        } else if (formField.type === "hardcoded") {
          returnData[formField.key] = formField.value;
        } else if (formField.type === "checkbox") {
          returnData[formField.key] = data[formField.key];
        } else if (formField.type === "multiple_text_fields") {
          const tempList: { name: string; id: number }[] = [];
          for (const item of data[formField.key]) {
            tempList.push(item);
          }
          returnData[formField.key] = tempList;
        }
      }
      return returnData;
    } else {
      const returnData: any = data;
      for (const formField of this.form.formFields[data.type - 1]) {
        if (formField.type === "query_dropdown") {
          if (data[formField.key] === 0) {
            returnData[formField.key] = undefined;
          } else {
            returnData[formField.key] = data[formField.key];
          }
        } else if (formField.type === "hardcoded") {
          returnData[formField.key] = formField.value;
        } else if (formField.type === "text") {
          returnData[formField.key] = data[formField.key];
        }
      }
      returnData["type"] = data.type;
      return returnData;
    }
  }

  public isFormCompleted(data: any): boolean {
    if (this.form.type === "single_form") {
      for (const field of this.form.formFields) {
        if (
          (field.type === "password" || field.type === "text") &&
          field.required
        ) {
          if (data[field.key] === undefined || data[field.key] === "") {
            return false;
          }
        }
      }
      return true;
    }
    return true;
  }
}
